// EVENTS.VIEWS.APP.SETTINGS.MANAGE_USERs

export const MANAGE_USERS = {
  PAGE_VISITED: 'manange_users-page_visited'
};
